import QlikWebSocketManager from 'websockets/manager/QlikWebSocketManager';
const { Queue } = require('dynamic-queue');

class QlikWebSocketService {
    constructor() {
        this.sockets = {};
        this.queue = new Queue();
    }

    async getOrCreateSocket(config) {
        return new Promise((resolve, reject) => {
            this.queue.push(async (next) => {
                resolve(await this.initialiseSocket(config));
                next();
            });
        });
    }

    async initialiseSocket(config) {
        let socket = this.getSocket(config.appId);

        if (socket != null) {
            return socket;
        }
        socket = await this.createSocket(config);
        return socket;
    }

    async createSocket(config) {
        console.info('create socket ', config.appId);
        const newSocket = new QlikWebSocketManager();

        if (newSocket.socketIsReady) {
            await newSocket.initSocket(config);
            this._addSocket(newSocket);
        }
        return newSocket;
    }

    async removeSocket(appId) {
        const socket = this.getSocket(appId);
        if (socket != null) {
            await socket.close();
            delete this.sockets[appId];
        }
    }

    async closeAllSockets() {
        Promise.all(
            Object.values(this.sockets).map(
                async (socket) => await socket.close()
            )
        );
    }

    _addSocket(socket) {
        if (!(socket.appId in this.sockets)) {
            this.sockets = {
                ...this.sockets,
                [socket.appId]: socket,
            };
        }
    }

    getSockets() {
        return this.sockets;
    }

    getSocket(appId) {
        return this.sockets[appId];
    }
}

export default QlikWebSocketService;
